var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.step === 1)?_c('RTWCStep1',{on:{"proceed":_vm.proceed}}):_c('RTWCStep2',{key:_vm.step2Key,attrs:{"file-id":_vm.response.file_id,"started":_vm.isRTWCStarted,"completed":_vm.isRTWCCompleted},on:{"restart":function($event){return _vm.restart()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }